import {IconProps} from './types'

export default function StormyIcon({size = 16, ...props}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M4.00001 10.884C3.29749 10.5505 2.68949 10.0466 2.23124 9.41826C1.773 8.78991 1.47906 8.05701 1.37613 7.28616C1.27319 6.51531 1.36454 5.73096 1.64186 5.0044C1.91918 4.27783 2.37368 3.63209 2.96405 3.12587C3.55442 2.61964 4.26194 2.26899 5.02231 2.10577C5.78268 1.94255 6.57179 1.97194 7.31791 2.19128C8.06403 2.41062 8.7435 2.81294 9.29457 3.36169C9.84565 3.91043 10.2508 4.5882 10.4733 5.33338H11.6667C12.4343 5.33204 13.1733 5.62503 13.7315 6.15205C14.2896 6.67906 14.6246 7.4 14.6673 8.16647C14.71 8.93294 14.4572 9.68662 13.9611 10.2724C13.4649 10.8581 12.7631 11.2314 12 11.3154"
        stroke="#6D6D6D"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.66667 8L6.66667 11.3333H9.33334L7.33334 14.6667"
        stroke="#EF4338"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
